import $ from 'jquery';

const SELECTORS = {
    IMAGE_ITEM: '.js-productCarousel-image',
    CAPTION: '.js-productCarousel-caption',
    CAPTION_HIDE: '.js-productCarousel-captionHide',
    CAPTION_SHOW: '.js-productCarousel-captionShow',
}

const CLASSES = {
    CAPTION_COLLAPSED: 'isCollapsed',
    CAPTION_HIDDEN_CLASS: 'captionHidden',
    HAS_CAPTION_CLASS: 'hasCaption',
};

const TRANSITION_DURATION = 250

export default class ProductCarouselView {
    constructor($element) {
        this.$element = $element;
        this.isEnabled = false;
        this.imageCount;

        this.init();
    }

    init = function() {
        this.setupHandlers()
            .createChildren()
            .layout()
            .enable();

        return this;
    };

    setupHandlers() {
        this.captionHideHandler = this.hideCaption.bind(this);
        this.captionShowHandler = this.showCaption.bind(this);

        return this;
    }

    createChildren() {
        this.$productImage = this.$element.find(SELECTORS.IMAGE_ITEM);
        this.$productCaption = this.$element.find(SELECTORS.CAPTION);
        this.$productCaptionHide = this.$element.find(SELECTORS.CAPTION_HIDE);
        this.$productCaptionShow = this.$element.find(SELECTORS.CAPTION_SHOW);

        return this;
    };

    layout() {
        this.$productImage.each(function() {
            var caption = $(this).find(SELECTORS.CAPTION);
            if (caption.length !== 0) {
                $(this).addClass(CLASSES.HAS_CAPTION_CLASS);
            }

            $(this).attr('aria-hidden', 'true');
        });

        this.$productCaptionHide.each(function() {
            $(this).attr('tabindex', '-1');
        });

        return this;
    };

    enable() {
        if (this.isEnabled === true) { return this; }
        this.isEnabled = true;

        this.setupVariables();

        this.$productCaptionHide.on('click', this.captionHideHandler);
        this.$productCaptionShow.on('click', this.captionShowHandler);

        return this;
    };

    setupVariables() {
        this.imageCount = this.$productImage.length;
    };

    showCaption() {
        this.$productCaption.removeClass(CLASSES.CAPTION_COLLAPSED);
        this.$element.removeClass(CLASSES.CAPTION_HIDDEN_CLASS);
    };

    hideCaption(e) {
        e.preventDefault();
        this.$productCaption.addClass(CLASSES.CAPTION_COLLAPSED);
        this.$element.addClass(CLASSES.CAPTION_HIDDEN_CLASS);
    };
};
